// ATTENTION
// Known issue in JSDOM but won't be resolved: https://github.com/jsdom/jsdom/issues/3492
// window.location properties are non-configurable in newer jsdom versions (Jest 30+).
// Use this helper so tests can mock location via vi.mock('@shared/utils/window.helper').
export const getLocation = (): Location => window.location;
